module.exports = __webpack_public_path__ + "media/images/job_from_scratch-9af7ac1adef2eb9861a2ab456cf4e8e1.svg";